
export const clientVersion = {
    BuildVersionFull: '2.17.0.12',
    BuildDescription: 'No build description provided'
}